/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ID } from '@/data/types/Basic';
import { ComponentType } from 'react';
import dynamic from 'next/dynamic';

export const contentManifestCustom: Record<string, ComponentType<{ id: ID }>> = {
	CartSkeleton: dynamic(() =>
		import('@/components/content/Cart/parts/CartSkeleton').then((mod) => mod.CartSkeleton)
	),
	ElementsLandings: dynamic(() =>
		import('@/components/content/ElementsLandings').then((mod) => mod.ElementsLandings)
	),
	ContentCarouselAds: dynamic(() =>
		import('@/components/content/ContentCarouselAds').then((mod) => mod.ContentCarouselAds)
	),
	ContentFavoriteCategories: dynamic(() =>
		import('@/components/content/ContentFavoriteCategories').then(
			(mod) => mod.ContentFavoriteCategories
		)
	),
	ContentCategoriesDepartureMen: dynamic(() =>
		import('@/components/content/Pages/DepartureMen/ContentCategoriesDepartureMen').then(
			(mod) => mod.ContentCategoriesDepartureMen
		)
	),
	ContentCategoriesDepartureHotSale: dynamic(() =>
		import('@/components/content/Pages/DepartureHotSale/ContentCategoriesDepartureHotSale').then(
			(mod) => mod.ContentCategoriesDepartureHotSale
		)
	),
	ContentMarksDepartureMen: dynamic(() =>
		import('@/components/content/Pages/DepartureMen/ContentMarksDepartureMen').then(
			(mod) => mod.ContentMarksDepartureMen
		)
	),
	ContentMarksElectron: dynamic(() =>
		import('@/components/content/ContentMarksElectronicos').then((mod) => mod.ContentMarksElectron)
	),
	ContentMarksHotSale: dynamic(() =>
		import('@/components/content/ContentMarksHotSale').then((mod) => mod.ContentMarksHotSale)
	),
	ContentPopulateDepartureMen: dynamic(() =>
		import('@/components/content/Pages/DepartureMen/ContentPopulateDepartureMen').then(
			(mod) => mod.ContentPopulateDepartureMen
		)
	),
	ContentPopulateTemporada: dynamic(() =>
		import('@/components/content/Pages/DepartureMen/ContentPopulateTemporada').then(
			(mod) => mod.ContentPopulateTemporada
		)
	),
	ContentPopulateDepartureHotSale: dynamic(() =>
		import('@/components/content/Pages/DepartureHotSale/ContentPopulateDepartureHotSale').then(
			(mod) => mod.ContentPopulateDepartureHotSale
		)
	),
	ContentTendences: dynamic(() =>
		import('@/components/content/ContentTendences').then((mod) => mod.ContentTendences)
	),
	ContentMiniCardsCategories: dynamic(() =>
		import('@/components/content/ContentMiniCardsCategories').then(
			(mod) => mod.ContentMiniCardCategories
		)
	),
	ContentBestOffers: dynamic(() =>
		import('@/components/content/ContentBestOffers').then((mod) => mod.ContentBestOffers)
	),
	ContentMarks: dynamic(() =>
		import('@/components/content/ContentMarks').then((mod) => mod.ContentMarks)
	),
	ContentMarksTemporada: dynamic(() =>
		import('@/components/content/ContentMarksTemporada').then((mod) => mod.ContentMarksTemporada)
	),
	ContentMostNew: dynamic(() =>
		import('@/components/content/ContentMostNew').then((mod) => mod.ContentMostNew)
	),
	ContentSeeYouRecent: dynamic(() =>
		import('@/components/content/ContentSeeYouRecent').then((mod) => mod.ContentSeeYouRecent)
	),
	ContentBenefits: dynamic(() =>
		import('@/components/content/ContentBenefits').then((mod) => mod.ContentBenefits)
	),
	ContentOufitDepartureMen: dynamic(() =>
		import('@/components/content/Pages/DepartureMen/ContentOutfitDepartureMen').then(
			(mod) => mod.ContentOufitDepartureMen
		)
	),
	BreadcrumbTrailWidget: dynamic(() =>
		import('@/components/content/BreadcrumbTrail').then((mod) => mod.BreadcrumbTrail)
	),
	BreadcrumbTrail801: dynamic(() =>
		import('@/components/content/BreadcrumbTrail').then((mod) => mod.BreadcrumbTrail)
	),
	ShortFooter: dynamic(() =>
		import('@/components/content/ShortFooter').then((mod) => mod.ShortFooter)
	),
	ShortHeader: dynamic(() =>
		import('@/components/content/ShortHeader').then((mod) => mod.ShortHeader)
	),
};
